module.exports = __webpack_public_path__ + "static/img/son1.e044df1f.png";